import { FinanceCircular } from '../types/catalog';
import { fiatCircular } from './fiatCircular';
import { jeepCircular, ramCircular } from './jeepRamCircular';
import { citroenCircular } from './citroenCircular';
import { renaultCircular } from './renaultCircular';
import { peugeotCircular } from './peugeotCircular';
import { volkswagenCircular } from './volkswagenCircular';

/** Circulares oficiales vigentes, una por marca. Al vencer, la marca vuelve a sus condiciones generales. */
export const financeCirculars: FinanceCircular[] = [
  fiatCircular,
  jeepCircular,
  ramCircular,
  citroenCircular,
  renaultCircular,
  peugeotCircular,
  volkswagenCircular,
];
